var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModernaWhiteLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 102,
    viewBox: "0 0 117 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45.6992,
    y: 40.332,
    width: 10.2607,
    height: 40.1006,
    rx: 5.13037,
    transform: "rotate(-31.9221 45.6992 40.332)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 51.6309,
    y: 11.2344,
    width: 10.2607,
    height: 40.1006,
    rx: 5.13037,
    transform: "rotate(-31.9221 51.6309 11.2344)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.464844,
    y: 6.35156,
    width: 10.2607,
    height: 102.293,
    rx: 5.13037,
    transform: "rotate(-31.9221 0.464844 6.35156)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 70.0664,
    y: 79.4414,
    width: 10.2607,
    height: 25.1148,
    rx: 5.13037,
    transform: "rotate(-31.9221 70.0664 79.4414)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 75.9775,
    y: 50.332,
    width: 10.2607,
    height: 60.8315,
    rx: 5.13037,
    transform: "rotate(-31.9221 75.9775 50.332)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 38.165,
    y: 28.25,
    width: 10.2607,
    height: 10.156,
    rx: 5.07802,
    transform: "rotate(-31.9221 38.165 28.25)",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModernaWhiteLogo);
export default __webpack_public_path__ + "static/media/moderna-white-logo.32fab68fdad0f92e92d4eb221e029358.svg";
export { ForwardRef as ReactComponent };